<template>
	<header class="header">
		<div class="fixedH">
			<div class="inner">
				<h1 class="logo"><a :href="hotsUrl()" class="logo" title="广东网联实业有限公司"><img src="/static/image/logo.png"/></a></h1>
				<ul class="nav_ul">
					<li v-if="param.pc_has_right==1" :class="{'hover':param.type==1}" @click="goToStr('pc')">
						<a href="###">
							<i></i><span>PC端</span>
						</a>
					</li>
					<li v-if="param.mobile_has_right==1" :class="{'hover':param.type==2||param.type==3||param.type==4||param.type==5}" @click="goToStr('m')">
						<a href="###">
							<i></i><span>移动端</span>
						</a>
					</li>
					<li v-if="param.manage!=1" @click="merialFun">
						<span class="materialLibrary">素材库</span>
					</li>
					<li v-if="param.manage==1" @click="merialFun">
						<span class="materialLibrary">管理素材库</span>
					</li>
					<li class="oneSteptoStation" @click="stepToStation">极速建站</li>
				</ul>
				<div class="Multilingual">
					<dl class="handleCommand">
						<dt><span class="el-dropdown-link">{{curLang}}<i class="el-icon-arrow-down el-icon--right"></i></span></dt>
						<dd class="dtCom" v-if="langData.length">
							<ul>
								<li v-for="(v,ind) in langData" v-if="v.code!=param.lang" @click="commandFun(JSON.stringify(v))" :keys="ind">{{v.name}}</li>
							</ul>
						</dd>
					</dl>
				</div>
				<div v-if="param.type!=1" class="Multilingual">
					<dl class="handleCommand">
						<dt><span class="el-dropdown-link">{{curType}}<i class="el-icon-arrow-down el-icon--right"></i></span></dt>
						<dd class="dtCom" v-if="typeData.length">
							<ul>
								<li v-for="(v,ind) in typeData" v-if="v.type!=param.type&&v.type!=1&&v.has_right==1" @click="typeFun(JSON.stringify(v))" :keys="ind">{{v.name}}</li>
							</ul>
						</dd>
					</dl>
				</div>
				<div class="h_center g-fr">
					<em class="st_link" @click="syncTemp">网站发布成模板</em>
					<span v-if="param.type!=1" @click="dialogTig = true" style="padding: 0 10px;"><a class="dt">小程序数据同步</a></span>
					<input type="button" @click="showBorderFun" class="preview purpleBg" value="保存" />
					<a @click="gotoPreview" href="javascript:;" class="preview">预览</a>
				</div>
			</div>

			<el-dialog title="选择基础模板" :modal=false :visible.sync="addVisibleNav" width="40%">
				<div class="g-cf add_nav_cons">
					<div style="min-height: 100px;" class="list_con">
						<label><input type="radio" name="mLbl" v-model="dataSynValue" value="none" />无</label>
						<label v-for="(v,index) in langData" v-if="v.code!=command.code" :keys="index"><input type="radio" name="mLbl" v-model="dataSynValue" :value="JSON.stringify(v)" />{{v.name}}</label>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
				    <el-button @click="addVisibleNav = false">取 消</el-button>
				    <el-button type="primary" @click="addVisibleFun">确　定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="选择基础模板" :modal=false :visible.sync="wxVisible" width="40%">
				<div class="g-cf add_nav_cons">
					<div style="min-height: 100px;" class="list_con">
						<label><input type="radio" name="mLbl" v-model="wxValue" value="none" />无</label>
						<label><input type="radio" name="mLbl" v-model="wxValue" value="h5" />手机端的模板数据</label>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
		    <el-button @click="wxVisible = false">取 消</el-button>
		    <el-button type="primary" @click="wxVisibleFun">确　定</el-button>
		  </span>
			</el-dialog>
			<el-dialog title="选择要同步到的项目" :visible.sync="dialogTig" width="30%">
				<div class="g-cf add_nav_cons">
					<div style="min-height: 100px;" class="list_con">
						<label v-for="(v,index) in typeData" :key="index" v-if="v.type!=param.type&&v.type!=1&&v.has_right==1"><input type="checkbox" name="h5Wxp" v-model="curTypeArr" :value="v.type" />{{v.name}}</label>

					</div>
				</div>
				<span slot="footer" class="dialog-footer">
			    <el-button @click="dialogTig = false">取 消</el-button>
			    <el-button type="primary" @click="syncData">确 定</el-button>
			  </span>
			</el-dialog>

			<el-dialog title="发布提示" :modal=false :visible.sync="isBorderBox" width="40%">
				<div class="g-cf add_nav_cons">
					<div style="min-height: 100px;" class="list_con">
						如果有页面有全屏拖动的模块建议开启虚线提示功能
						<p style="color: red;">PS:关闭可解决模块间隙问题</p>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
			    	<el-button @click="openBorderFun">开 启</el-button>
			    	<el-button type="primary" @click="colerBorderFun">关 闭</el-button>
			    </span>
			</el-dialog>
		</div>
	</header>
</template>
<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	import api from '@/api/$ajax.js'
	import Vue from 'vue'
	var vue = new Vue();
	export default {
		name: 'headerNav',
		data() {
			return {
				addVisibleNav: false,
				dialogTig: false,
				adv: "",
				appId: "",
				wxUrl: "",
				isBorderBox: false,
				langData: [],
				typeData: [],
				curTypeArr: [],
				command: {},
				wxVisible: false,
				wxValue: "",
				h5Value: "",
				curLang: "中文",
				curType: "H5版",
				dataSynValue: {},
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					manage: this.$route.query.manage,
					lang: this.$route.query.lang,
					domain_m: "",
					mobile_version_index_id: "",
					domain_wxp: "",
					domain_url: this.$route.query.domain_url,
					wxp_version_id: "",
					wxp_version_index_id: "",
					pc_has_right: "",
					mobile_has_right: "",
					wxp_has_right: "",
					pc_version_id: this.$route.query.pc_version_id,
					mobile_version_id: this.$route.query.mobile_version_id
				},
				msg: 'header'
			}
		},
		created() {
			let ts = this;
			ts.getData();
			ts.getColumnList();
		},
		methods: {
			hotsUrl() {
				return window.location.origin.replace("diy", "open").replace(".com", ".cn"); //lyf logo跳转
			},
			syncTemp() {
				let ts = this;
				ts.$confirm('您确定要将此网站发布成模板?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log("删除成功");
				}).catch(() => {
					console.log("已取消删除");
				});
			},
			openBorderFun() {
				var ts = this;
				ts.gotoSaveCom();
				ts.isBorderBox = false;
				ts.state.hasTipsBorder = false;
			},
			syncData(v) {
				let ts = this;
				ts.dialogTig = false;
				$("#loadGit").show();
				api.get('/api/template/copy?src=' + ts.param.type + '&destList=' + ts.curTypeArr.join(), false, {}, r => {
					if(r.code == 422) {
						return;
					}
					//console.log(r.message);
					vue.$msg(r.data.msg);
					ts.getUserInfo();
					$("#loadGit").hide();
				});
				// debugger
			},
			typeFun(v) {
				let ts = this;
				console.log(v);
				let command = JSON.parse(v);
				let url = window.location.origin;
				url = '/t2/' + ts.$route.params.id + '/' + command.version_index_id + '?token=' + ts.param.token + '&company_id=' + ts.$route.query.company_id + '&type=' + command.type + '&mobile_version_id=' + command.version_id + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + command.domain + '&lang=' + ts.param.lang;
				location.href = url;
			},
			merialFun() {
				// debugger
				this.$emit("oneMaterialFun");
			},
			showBorderFun() {
				this.isBorderBox = true;
			},
			colerBorderFun() {
				var ts = this;
				ts.state.hasTipsBorder = true;
				ts.gotoSaveCom();
				ts.isBorderBox = false;
			},
			commandFun(command) {
				let ts = this;
				ts.command = JSON.parse(command);
				let url = window.location.origin;
				if(ts.command.column_id && ts.command.has_content == 1 && ts.$route.name == 't1') {
					url += '/t1/' + ts.$route.params.id + "/" + ts.command.column_id + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.command.version_id + '&mobile_version_id=' + ts.$route.query.mobile_version_id + '&lang=' + ts.command.code + '&domain_url=' + ts.$route.query.domain_url;
					location.href = url;
					return;
				} else if(ts.command.column_id && ts.command.has_content == 1 && ts.$route.name == 't2') {
					url += '/t2/' + ts.$route.params.id + "/" + ts.command.column_id + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.$route.query.pc_version_id + '&mobile_version_id=' + ts.command.version_id + '&lang=' + ts.command.code + '&domain_url=' + ts.$route.query.domain_url;
					location.href = url;
					return;
				}
				ts.addVisibleNav = true;
			},
			dataSyn() {
				let oldVersionId, ts = this;
				let url = window.location.origin;
				if(ts.dataSynValue == "none") {
					if(ts.$route.name == 't1') {
						url += '/t1/' + ts.$route.params.id + "/" + ts.command.column_id + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.command.version_id + '&mobile_version_id=' + ts.$route.query.mobile_version_id + '&lang=' + ts.command.code + '&domain_url=' + ts.$route.query.domain_url;
					} else if(ts.$route.name == 't2') {
						url += '/t2/' + ts.$route.params.id + "/" + ts.command.column_id + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.$route.query.mobile_version_id + '&mobile_version_id=' + ts.command.version_id + '&lang=' + ts.command.code + '&domain_url=' + ts.$route.query.domain_url;
					}
					location.href = url;
					return;
				}
				api.get('/api/data/move?oldVersionId=' + JSON.parse(ts.dataSynValue).version_id + '&newVersionId=' + ts.command.version_id, false, {}, r => {
					if(r.code == 422) {
						console.log(r.message);
						return;
					}

					if(ts.$route.name == 't1') {
						url += '/t1/' + ts.$route.params.id + "/" + r.data.columnId + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.command.version_id + '&mobile_version_id=' + ts.$route.query.mobile_version_id + '&lang=' + ts.command.code + '&domain_url=' + ts.$route.query.domain_url;
					} else if(ts.$route.name == 't2') {
						url += '/t2/' + ts.$route.params.id + "/" + r.data.columnId + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.$route.query.pc_version_id + '&mobile_version_id=' + ts.command.version_id + '&lang=' + ts.command.code + '&domain_url=' + ts.$route.query.domain_url;
					} else if(ts.$route.name == 't3') {
						url += '/t3/' + ts.$route.params.id + "/" + r.data.columnId + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.command.version_id + '&mobile_version_id=' + ts.$route.query.mobile_version_id + '&lang=' + ts.command.code + '&domain_url=' + ts.$route.query.domain_url;
					}
					location.href = url;
				});
			},
			addVisibleFun() {
				let ts = this;
				ts.addVisibleNav = false;
				ts.dataSyn();
			},
			gotoPreview: function() {
				let ts = this;
				ts.colerBorderFun();
				var url = window.location.origin;
				if(ts.$route.name == 't1') {
					url += '/t1/prev/' + ts.$route.params.id + "/" + ts.$route.params.param + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&pc_version_id=' + ts.$route.query.pc_version_id + '&mobile_version_id=' + ts.$route.query.mobile_version_id + (ts.$route.query.productId ? "&productId=" + ts.$route.query.productId : "") + (ts.$route.query.detailId ? "&detailId=" + ts.$route.query.detailId : "") + (ts.$route.query.newDesId ? "&newDesId=" + ts.$route.query.newDesId : "") + '&domain_url=' + ts.$route.query.domain_url + '&lang=' + ts.param.lang + (ts.$route.query.keyword ? "&keyword=" + ts.$route.query.keyword : "") + (ts.$route.query.productCategory ? "&productCategory=" + ts.$route.query.productCategory : "");
					//debugger
				} else if(ts.$route.name == 't2') {
					url += '/t2/prev/' + ts.$route.params.id + "/" + ts.$route.params.param + '?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&mobile_version_id=' + ts.$route.query.mobile_version_id + (ts.$route.query.productId ? "&productId=" + ts.$route.query.productId : "") + (ts.$route.query.detailId ? "&detailId=" + ts.$route.query.detailId : "") + (ts.$route.query.newDesId ? "&newDesId=" + ts.$route.query.newDesId : "") + '&pc_version_id=' + ts.$route.query.pc_version_id + '&domain_url=' + ts.$route.query.domain_url + '&lang=' + ts.param.lang + (ts.$route.query.keyword ? "&keyword=" + ts.$route.query.keyword : "") + (ts.$route.query.productCategory ? "&productCategory=" + ts.$route.query.productCategory : "");
				}
				window.open(url);
			},
			stepToStation() {
				this.$emit("oneStepFun");
			},
			wxVisibleFun() {
				let ts = this;
				let url = window.location.origin;
				ts.wxVisible = false;
				if(ts.wxValue == "none") {
					//debugger
					url += '/t3/' + ts.param.id + "/" + ts.param.wxp_version_index_id + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=3' + '&pc_version_id=' + ts.param.pc_version_id + '&mobile_version_id=' + ts.param.mobile_version_id + '&lang=' + ts.param.lang + '&domain_url=' + ts.param.domain_wxp;
					location.href = url;
					return;
				}
				api.get('/api/template/h5ToWxp', false, {}, r => {
					if(r.code == 422) {
						console.log(r.message);
						return;
					}
					url = '/t3/' + ts.param.id + '/' + ts.param.wxp_version_index_id + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=3' + '&mobile_version_id=' + ts.param.mobile_version_id + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + ts.param.domain_wxp + '&lang=' + ts.param.lang;
					location.href = url;
				});

			},
			getData() {
				var ts = this;
				//debugger
				api.get('/api/data/lang', false, {}, r => {
					if(r.code == 422 || r.code == 2) {
						return;
					}
					//debugger
					ts.langData = r.data.lang_list;
					for(var i = 0; ts.langData.length > i; i++) {
						//debugger
						if(ts.langData[i].code == ts.param.lang) {
							ts.curLang = ts.langData[i].name;
							//debugger
						}
					}
				});
				ts.getUserInfo();

			},
			getUserInfo() {
				let ts = this;
				api.get('/api/template/userInfo', false, {
					lang: ts.param.lang
				}, r => {
					if(r.code == 422||r.code == 2) {
						console.log(r.message);
						return;
					}
					//debugger;
					ts.param.domain_pc = r.data.typeData[0].domain;
					if(r.data.typeData.length>1){
						ts.param.domain_m = r.data.typeData[1].domain;
						ts.param.mobile_version_id = r.data.typeData[1].version_id;
					}

					for(var i = 0;r.data.typeData.length>i;i++){
						if(ts.param.type==r.data.typeData[i].type){
							ts.curType = r.data.typeData[i].name;
						}
					}

					//ts.param.domain_wxp = r.data.typeData[2].domain;
					//ts.param.domain_baidu = r.data.typeData[3].domain;

					//ts.param.mobile_version_index_id = r.data.typeData[1].version_index_id;
					//ts.param.wxp_version_index_id = r.data.typeData[2].version_index_id;
					//ts.param.baidu_version_index_id = r.data.typeData[3].version_index_id;

					//ts.param.mobile_version_id = r.data.typeData[1].version_id;
					//ts.param.wxp_version_id = r.data.typeData[2].version_id;
					//ts.param.baidu_version_id = r.data.typeData[3].version_id;

					ts.param.pc_has_right = r.data.typeData[0].has_right;
					ts.param.mobile_has_right = r.data.typeData.length>1;
					//ts.param.wxp_has_right = r.data.typeData[2].has_right;
					//ts.param.baidu_has_right = r.data.typeData[3].has_right;

					//ts.param.mobile_version_id = r.data.mobile_version_id;
					//ts.curType = r.data.typeData[ts.param.type - 1].name;
					ts.typeData = r.data.typeData;
					//debugger
					localStorage.setItem("info", JSON.stringify(ts.param));
				});
			},
			getColumnList() {
				//debugger
				let param = this.param;
				let version_id = param.pc_version_id;
				if(param.type == 2) {
					version_id = param.mobile_version_id;
				} else if(param.type == 3) {
					version_id = param.mobile_version_id;
				} else if(param.type == 4) {
					version_id = param.mobile_version_id;
				}
				//debugger
				api.get('/api/data/columnList?template_id=' + param.id + "&m=header", false, {}, r => {
					if(r.code == 422||r.code == 2) {
						console.log(r.message);
						return;
					}

					var list = r.data.list;
					// debugger;
					var firstList = [];
					for(let i = 0; list.length > i; i++) {
						list[i].secondNav = [];
						if(list[i].parent_id == 0) {
							firstList.push(list[i])
						}
					}

					for(let i = 0; firstList.length > i; i++) {
						for(let k = 0; list.length > k; k++) {
							list[k].thirdNav = [];
							if(firstList[i].id == list[k].parent_id) {
								firstList[i].secondNav.push(list[k])
							}
						}
					}

					for(let i = 0; firstList.length > i; i++) {
						for(let k = 0; firstList[i].secondNav.length > k; k++) {
							for(let j = 0; list.length > j; j++) {
								if(firstList[i].secondNav[k].id == list[j].parent_id) {
									firstList[i].secondNav[k].thirdNav.push(list[j])
								}
							}
						}
					}

					localStorage.setItem("columnList", JSON.stringify(r.data.list));
				});
			},
			gotoSaveCom() {
				let ts = this;
				if(ts.$route.name == 't1') {
					ts.param.version_id = ts.param.pc_version_id;
				} else if(ts.$route.name == 't2') {
					ts.param.version_id = ts.$route.query.mobile_version_id;
				} else if(ts.$route.name == 't3') {
					ts.param.version_id = ts.$route.query.mobile_version_id;
				}
				//debugger
				$("#loadGit").show();
       
				ts.saveData(ts.param);
			},
			frWx() {
				this.dialogTig = true;
			},
			materialFun(url) {
				window.location.href = window.location.origin + url;
			},
			fincSave() {
				var ts = this;
				var url = window.location.origin;
				if(ts.h5Value == "none") {
					url = '/t2/' + ts.$route.params.id + '/' + ts.param.mobile_version_index_id + '?token=' + ts.param.token + '&company_id=' + ts.$route.query.company_id + '&type=2' + '&mobile_version_id=' + info.mobile_version_id + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + ts.param.domain_m + '&lang=' + ts.param.lang;
					location.href = url;
					return;
				}
				api.get('/api/template/wxpToH5', false, {}, r => {
					if(r.code == 422) {
						console.log(r.message);
						return;
					}
					url = '/t2/' + ts.$route.params.id + '/' + ts.param.mobile_version_index_id + '?token=' + ts.param.token + '&company_id=' + ts.$route.query.company_id + '&type=2' + '&mobile_version_id=' + ts.param.mobile_version_id + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + ts.param.domain_m + '&lang=' + ts.param.lang;
					location.href = url;
				});
				ts.dialogTig = false;
			},
			goToStr(param) {
				var url = "",
					ts = this;
				var info = localStorage.getItem("info");
				info = JSON.parse(info);
				if(param == "pc") {
					api.get('/api/data/columnList?template_id=' + ts.param.id + "&version_id=" + ts.param.pc_version_id, false, {}, r => {
						if(r.code == 422) {
							console.log(r.message);
							return;
						}
						url = '/pc/t1/' + ts.$route.params.id + '/' + r.data.list[0].id + '?token=' + ts.param.token + '&company_id=' + ts.$route.query.company_id + '&type=1' + '&mobile_version_id=' + ts.param.mobile_version_id + '&pc_version_id=' + ts.$route.query.pc_version_id + '&domain_url=' + info.domain_pc + '&lang=' + ts.param.lang;
						//localStorage.setItem("columnList" + ts.$route.params.id + ts.$route.params.type, JSON.stringify(r.data.list));
					});
				} else if(param == "m") {
					if(info.wxp_has_content == 1 && info.mobile_has_content == 0) {
						ts.wxVisible = true;
						return;
					}

					api.get('/api/data/columnList?template_id=' + ts.param.id + "&version_id=" + info.mobile_version_id, false, {}, r => {
						if(r.code == 422) {
							console.log(r.message);
							return;
						}
						 //debugger;
						url = '/t2/' + ts.$route.params.id + '/' + r.data.list[0].id + '?token=' + ts.param.token + '&company_id=' + ts.$route.query.company_id + '&type=2' + '&mobile_version_id=' + info.mobile_version_id + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + info.domain_m + '&lang=' + ts.param.lang;
					});
					// debugger;
				} else if(param == "wx") {
					// debugger
					if(info.mobile_has_content == 1 && info.wxp_has_content == 0) {
						ts.wxVisible = true;
						return;
					}
					api.get('/api/data/columnList?template_id=' + ts.param.id + "&version_id=" + info.wxp_version_id, false, {}, r => {
						if(r.code == 422) {
							console.log(r.message);
							return;
						}
						url = '/t3/' + ts.$route.params.id + '/' + r.data.list[0].id + '?token=' + ts.param.token + '&company_id=' + info.company_id + '&type=3' + '&mobile_version_id=' + info.wxp_version_id + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + info.domain_wxp + '&lang=cn';
					});

				}

				if(url) {
					window.location.href = window.location.origin + url;
				}

			},
			...mapActions([
				'saveData', 'saveloca'
			]),
			...mapMutations([
				'setOrderId', 'previewData'
			])
		},
		computed: {
			...mapGetters(["state"])
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.header {
		height: 80px;
		margin-top: 0;
		position: relative;
		z-index: 3333334334;
		margin-bottom: 20px;
	}

	.Multilingual {
		float: left;
		height: 80px;
		cursor: pointer;
		border-right: 1px solid #E3E3E3;
		.el-dropdown-link {
			margin-top: 27px;
			margin-left: 17px;
			margin-right: 17px;
			display: block;
		}
		.handleCommand {
			position: relative;
		}
		li {
			height: 40px;
			line-height: 40px;
			text-align: center;
		}
		li:first-child {
			border-left: none;
			height: 40px;
			line-height: 40px;
			text-align: center;
		}
		li:last-child {
			border-right: none;
		}
		.dtCom {
			position: absolute;
			width: 111px;
			display: none;
			left: 0;
			top: 50px;
			z-index: 20;
			background-color: #fff;
			box-shadow: 0px 0px 6px #ccc;
			border-radius: 5px;
			border: 1px solid #ccc;
		}
	}

	.Multilingual:hover {
		.dtCom {
			display: block;
		}
	}

	.list_con {
		padding-top: 30px;
		padding-left: 50px;
		label {
			float: left;
			margin-right: 20px;
			input {
				display: inline-block;
				margin-right: 5px;
			}
		}
	}

	.fixedH {
		box-sizing: border-box;
		width: 100%;
		height: 80px;
		margin: 0;
		background-color: #fff;
		padding: 0 40px;
		box-shadow: 0 2px 10px 0px rgba(0, 0, 0, 0.15);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999999;
	}

	.inner {
		clear: both;
	}

	.h_center {
		padding-top: 20px;
		span {
			width: 100px;
			height: 35px;
			display: inline-block;
			line-height: 35px;
			margin: 0 0 0 20px;
			text-align: center;
			background: #fff;
			color: #777;
			border: 1px solid #d4d4d4;
			border-radius: 5px;
			cursor: pointer;
			transition: all 0.5s;
			-moz-transition: all 0.5s;
			-webkit-transition: all 0.5s;
			-o-transition: all 0.5s;
		}
		span:hover {
			background: #0D83ED;
			color: #FFFFFF;
			border: 1px solid #0D83ED;
		}
		.preview {
			width: 100px;
			height: 35px;
			display: inline-block;
			line-height: 35px;
			margin: 0 0 0 20px;
			text-align: center;
			background: #fff;
			color: #777;
			border: 1px solid #d4d4d4;
			border-radius: 5px;
			cursor: pointer;
			transition: all 0.5s;
			-moz-transition: all 0.5s;
			-webkit-transition: all 0.5s;
			-o-transition: all 0.5s;
		}
		.st_link {
			color: #0D83ED;
			cursor: pointer;
		}
		.purpleBg {
			background: #0D83ED;
			color: #fff;
		}
		.preview:hover {
			background: #0D83ED;
			color: #FFFFFF;
			border: 1px solid #0D83ED;
		}
	}

	.logo {
		float: left;
		line-height: 80px;
		margin-right: 30px;
	}

	ul.nav_ul {
		float: left;
		li {
			float: left;
			width: 110px;
			font-weight: normal;
			border-right: 1px solid #E3E3E3;
			line-height: 80px;
			text-align: center;
			cursor: pointer;
			font-size: 14px;
			color: #555555;
			a {
				color: #555555;
				display: inline-block;
				position: relative;
				i {
					display: block;
					position: absolute;
					top: 46%;
					margin-top: -12px;
					width: 28px;
					height: 24px;
					background: url(/static/image/indexNav.png);
				}
				span {
					padding-left: 38px;
				}
			}
		}
		li:nth-child(1) a i {
			background-position: -7px -8px;
		}
		li:nth-child(2) a i,
		li:nth-child(3) a i {
			background-position: -40px -8px;
		}
		li:nth-child(2) a,
		li:nth-child(3) a i {
			i {
				width: 20px;
			}
			span {
				padding-left: 32px;
			}
		}
		li:first-child {
			border-left: 1px solid #E3E3E3;
		}
		li:hover a,
		li.hover a {
			color: #0D83ED;
		}
		li:nth-child(1):hover a i,
		li:nth-child(1).hover a i {
			background-position: -65px -8px;
		}
		li:nth-child(2):hover a i,
		li:nth-child(2).hover a i li:nth-child(3):hover a i,
		li:nth-child(3).hover a i {
			background-position: -98px -8px;
		}
	}

	.wx_tig {
		padding: 30px;
		li {
			margin-bottom: 20px;
		}
		.tips {
			color: #888;
			padding-left: 165px;
			line-height: 30px;
		}
		.lbl {
			display: inline-block;
			height: 30px;
			line-height: 30px;
			width: 160px;
			padding-right: 4px;
			text-align: right;
		}
		.txt {
			border: 1px solid #eee;
			height: 30px;
			line-height: 30px;
			padding: 3px 0 3px 6px;
			border-radius: 5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/m/header.vue